function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 0,
  fill: "none",
  stroke: "#0c2fe9",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0;40",
  keyTimes: "0;1",
  keySplines: "0 0.2 0.8 1",
  calcMode: "spline",
  begin: "-0.5s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  repeatCount: "indefinite",
  dur: "1s",
  values: "1;0",
  keyTimes: "0;1",
  keySplines: "0.2 0 0.8 1",
  calcMode: "spline",
  begin: "-0.5s"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 0,
  fill: "none",
  stroke: "#e90c59",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0;40",
  keyTimes: "0;1",
  keySplines: "0 0.2 0.8 1",
  calcMode: "spline"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  repeatCount: "indefinite",
  dur: "1s",
  values: "1;0",
  keyTimes: "0;1",
  keySplines: "0.2 0 0.8 1",
  calcMode: "spline"
}));

var SvgLoaderSmall = function SvgLoaderSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "#FFFFFF",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoaderSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader_small.cf6f41cd.svg";
export { ForwardRef as ReactComponent };